export default "__VITE_ASSET__CV8kF1aN__"